var _mask, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoosePairVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5398_13820",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "url(#paint0_linear_5398_13820)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V1H22V0V-1H10V0ZM32 10H31V22H32H33V10H32ZM22 32V31H10V32V33H22V32ZM0 22H1V10H0H-1V22H0ZM10 32V31C5.02944 31 1 26.9706 1 22H0H-1C-1 28.0751 3.92487 33 10 33V32ZM32 22H31C31 26.9706 26.9706 31 22 31V32V33C28.0751 33 33 28.0751 33 22H32ZM22 0V1C26.9706 1 31 5.02944 31 10H32H33C33 3.92487 28.0751 -1 22 -1V0ZM10 0V-1C3.92487 -1 -1 3.92487 -1 10H0H1C1 5.02944 5.02944 1 10 1V0Z",
    fill: "#AD46FF",
    fillOpacity: 0.3,
    mask: "url(#path-1-inside-1_5398_13820)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 12.666H22.6665V16.666",
    stroke: "#DAB2FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6668 12.666L17.0002 18.3327L13.6668 14.9993L9.3335 19.3327",
    stroke: "#DAB2FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5398_13820",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9810FA",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoosePairVector);
export default __webpack_public_path__ + "static/media/choose-pair-vector.1b442c60cc9b4d01faf1225563338c8c.svg";
export { ForwardRef as ReactComponent };